'use client';

import React, { useMemo } from 'react';
import { Flex } from '@skin-seoul/design-system';
import { usePathname } from 'next/navigation';
import MobileNavbarItem from './components/MobileNavbarItem';
import LegacyHomeIcon from '@/assets/LegacyHomeIcon';
import LegacyTrendIcon from '@/assets/LegacyTrendIcon';
import LegacyCategoryIcon from '@/assets/LegacyCategoryIcon';
import LegacyUserIcon from '@/assets/LegacyUserIcon';
import { useSafeRouter } from '@/hooks/useSafeRouter';
import { getLayoutOptions } from '@/utils/layout/layoutFilter';
import ProductCategoryModal from '@/components/products/ProductCategoryModal/ProductCategoryModal';
import { useCartDrawer, ShoppingBagButton } from '@skin-seoul/shared-components';
import { CLASSNAME, useRegionCurrency } from '@skin-seoul/service';
const MobileNavbar = () => {
  const router = useSafeRouter();
  const pathname = usePathname();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const {
    onCartToggle,
    onCartClose
  } = useCartDrawer();
  const {
    country
  } = useRegionCurrency();
  const {
    mobileNavbar
  } = getLayoutOptions(pathname);
  const MOBILE_NAVBAR_ITEMS = useMemo(() => [{
    icon: <LegacyHomeIcon />,
    label: 'Home',
    onClick: () => {
      onCartClose();
      router.push('/');
    }
  }, {
    icon: <LegacyCategoryIcon />,
    label: 'Categories',
    onClick: () => {
      onCartClose();
      setIsModalOpen(prev => !prev);
    }
  }, {
    icon: <LegacyTrendIcon />,
    label: 'Trend',
    onClick: () => {
      onCartClose();
      router.push('/trend/');
    }
  }, {
    icon: <ShoppingBagButton country={country} iconProps={{
      color: 'neutral.200',
      strokeWidth: 0.5
    }} />,
    label: 'Cart',
    onClick: () => {
      onCartToggle();
    }
  }, {
    icon: <LegacyUserIcon />,
    label: 'Me',
    onClick: () => {
      onCartClose();
      router.push('/my-account/');
    }
  }], [router, onCartToggle, onCartClose, country]);
  if (!mobileNavbar) {
    return null;
  }
  return <>
      <ProductCategoryModal onClose={() => setIsModalOpen(false)} isOpen={isModalOpen} data-sentry-element="ProductCategoryModal" data-sentry-source-file="MobileNavbar.tsx" />
      <Flex as="nav" display={{
      base: 'flex',
      mobile: 'flex',
      tablet: 'none',
      desktop: 'none'
    }} boxShadow="2px 0 12px 0 rgb(0 0 0 / .15)" position="fixed" bottom="0" width="100vw" height="fit-content" backgroundColor="white" zIndex="popover" paddingBottom="env(safe-area-inset-bottom)" className={CLASSNAME.NOT_TRANSLATE} data-sentry-element="Flex" data-sentry-source-file="MobileNavbar.tsx">
        {MOBILE_NAVBAR_ITEMS.map(item => <MobileNavbarItem key={item.label} icon={item.icon} label={item.label} onClick={item.onClick} />)}
      </Flex>
    </>;
};
export default MobileNavbar;